<template>
  <div class="about-us">
    <div class="header"></div>
    <div class="main">
      <p class="main-title">隐私政策</p>
      
      <div class="policy-content">
        <p class="update-date">更新日期：2026年7月9日</p>
        <p class="update-date">生效日期：2026年7月9日</p>
        
        <p class="main-content">
          <strong>天府再生云</strong>（以下简称"我们"或"本应用"）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。我们致力于维持您对我们的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
        </p>
        
        <p class="main-content">
          请您在使用本应用前，仔细阅读并了解本《隐私政策》。如果您不同意本政策的任何内容，请不要使用本应用。您的使用行为将视为对本政策全部内容的完全理解和接受。
        </p>

        <h2 class="section-title">1. 我们如何收集您的个人信息</h2>
        
        <h3 class="subsection-title">1.1 您直接提供的信息</h3>
        <p class="main-content">
          为向您提供再生资源回收交易服务，我们可能会收集您主动提供的以下信息：
        </p>
        <ul class="content-list">
          <li><strong>账户信息</strong>：手机号码、用户名、密码、头像、昵称；</li>
          <li><strong>个人身份认证信息</strong>：姓名、身份证信息（如进行身份认证时）；</li>
          <li><strong>企业信息</strong>（如注册企业用户）：单位名称、营业执照、单位地址、单位类型、联系人姓名、联系人电话、企业简介；</li>
          <li><strong>地址信息</strong>：收货地址、发货地址、地理位置坐标；</li>
          <li><strong>发布信息</strong>：您发布的回收需求、回收物品描述、照片；</li>
          <li><strong>交易信息</strong>：订单信息、发货记录、库存数据、交易价格；</li>
          <li><strong>客服沟通记录</strong>：您与客服团队沟通时提供的信息。</li>
        </ul>

        <h3 class="subsection-title">1.2 我们自动收集的信息</h3>
        <p class="main-content">
          当您使用本应用时，我们可能自动收集以下信息：
        </p>
        <ul class="content-list">
          <li><strong>设备信息</strong>：设备型号、操作系统版本、设备标识符（IDFA/IDFV）、IP地址、屏幕分辨率、设备语言设置；</li>
          <li><strong>网络信息</strong>：网络类型（WiFi/4G/5G）、网络运营商、连接状态；</li>
          <li><strong>应用使用信息</strong>：访问时间、浏览页面、点击记录、操作日志、崩溃日志；</li>
          <li><strong>位置信息</strong>：您的精确位置（GPS坐标）和粗略位置，用于展示附近回收站点、计算距离、填写地址；</li>
          <li><strong>照片与媒体信息</strong>：您通过相机拍摄或相册选择的照片、图片文件。</li>
        </ul>

        <h3 class="subsection-title">1.3 第三方SDK收集的信息</h3>
        <p class="main-content">
          为了提供完整的服务体验，我们接入了以下第三方SDK，它们可能会收集您的部分信息：
        </p>
        <table class="policy-table">
          <thead>
            <tr>
              <th>第三方SDK</th>
              <th>所属公司</th>
              <th>使用目的</th>
              <th>可能收集的信息</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>高德地图SDK</td>
              <td>高德软件有限公司</td>
              <td>地图展示、定位服务、地理编码</td>
              <td>位置信息、设备信息、网络信息</td>
            </tr>
            <tr>
              <td>微信OpenSDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>微信登录、微信分享、微信客服</td>
              <td>设备标识符、网络信息、微信头像与昵称</td>
            </tr>
            <tr>
              <td>Sign in with Apple</td>
              <td>Apple Inc.</td>
              <td>iOS端用户登录</td>
              <td>Apple ID标识符、姓名、邮箱（可选）</td>
            </tr>
            <tr>
              <td>uni-app框架</td>
              <td>数字天堂（北京）网络技术有限公司</td>
              <td>跨平台应用运行基础</td>
              <td>设备信息、应用运行日志</td>
            </tr>
          </tbody>
        </table>

        <h2 class="section-title">2. 我们如何使用您的个人信息</h2>
        <p class="main-content">
          我们使用您的个人信息用于以下目的：
        </p>
        
        <h3 class="subsection-title">2.1 核心服务功能</h3>
        <ul class="content-list">
          <li>注册、登录和管理您的账户；</li>
          <li>展示附近回收站点和计算距离；</li>
          <li>发布、查询和管理回收需求与供应信息；</li>
          <li>完成回收订单的撮合、确认和交易；</li>
          <li>企业资质认证与审核；</li>
          <li>地址管理与地图定位。</li>
        </ul>

        <h3 class="subsection-title">2.2 服务优化与安全</h3>
        <ul class="content-list">
          <li>改进和优化应用性能与用户体验；</li>
          <li>诊断和修复技术问题；</li>
          <li>检测和防范欺诈、滥用行为及安全风险；</li>
          <li>保障交易安全与平台秩序。</li>
        </ul>

        <h3 class="subsection-title">2.3 沟通与通知</h3>
        <ul class="content-list">
          <li>向您发送服务通知、订单状态更新；</li>
          <li>响应您的客服请求和反馈；</li>
          <li>向您推送您可能感兴趣的回收资讯（您可以在设置中关闭）。</li>
        </ul>

        <h3 class="subsection-title">2.4 合规与法律义务</h3>
        <ul class="content-list">
          <li>遵守适用的法律法规要求；</li>
          <li>响应政府主管部门的合法请求；</li>
          <li>保护我们、您或公众的合法权益、财产或安全。</li>
        </ul>

        <h2 class="section-title">3. 我们如何使用系统权限</h2>
        <p class="main-content">
          本应用需要获取以下系统权限以提供相应功能：
        </p>
        <table class="policy-table">
          <thead>
            <tr>
              <th>权限名称</th>
              <th>权限类型</th>
              <th>使用目的</th>
              <th>是否可选</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>位置权限（使用期间）</td>
              <td>敏感权限</td>
              <td>展示附近回收站点、计算距离、地址定位</td>
              <td>可选，但拒绝后将无法使用附近站点功能</td>
            </tr>
            <tr>
              <td>位置权限（始终）</td>
              <td>敏感权限</td>
              <td>持续位置追踪（仅在需要后台导航时使用）</td>
              <td>可选，默认不申请</td>
            </tr>
            <tr>
              <td>相机权限</td>
              <td>敏感权限</td>
              <td>拍摄回收物品照片、营业执照、资质证件</td>
              <td>可选，但拒绝后将无法拍照上传</td>
            </tr>
            <tr>
              <td>相册/照片权限</td>
              <td>敏感权限</td>
              <td>选择照片上传回收物品、证件图片</td>
              <td>可选，但拒绝后将无法选择图片</td>
            </tr>
            <tr>
              <td>存储权限</td>
              <td>普通权限</td>
              <td>保存和读取应用必要数据、缓存图片</td>
              <td>可选，但可能影响离线功能</td>
            </tr>
            <tr>
              <td>网络访问权限</td>
              <td>普通权限</td>
              <td>连接服务器、获取数据</td>
              <td>必需</td>
            </tr>
          </tbody>
        </table>
        
        <p class="main-content">
          <strong>重要说明</strong>：
        </p>
        <ul class="content-list">
          <li>上述敏感权限仅在您首次使用相关功能时，通过系统弹窗向您申请，您有权拒绝授权；</li>
          <li>您可以在设备的"设置"中随时撤销或修改授权状态；</li>
          <li>我们不会因您拒绝授权而停止提供基本功能服务，但拒绝授权可能导致部分功能无法正常使用。</li>
        </ul>

        <h2 class="section-title">4. 我们如何共享、转让和披露您的个人信息</h2>
        
        <h3 class="subsection-title">4.1 共享</h3>
        <p class="main-content">
          我们不会向任何第三方出售或出租您的个人信息。但在以下情形中，我们可能会与第三方共享您的信息：
        </p>
        <ul class="content-list">
          <li><strong>业务合作伙伴</strong>：为向您提供再生资源回收交易服务，我们可能与回收站点、回收企业等合作伙伴共享您的订单信息、联系方式，以便完成交易撮合；</li>
          <li><strong>第三方服务提供商</strong>：我们聘请第三方公司协助我们提供服务（如地图服务、云服务、支付服务、客户支持），这些服务提供商仅在为我们提供服务的必要范围内访问您的个人信息，并受合同约束保护您的信息安全；</li>
          <li><strong>关联公司</strong>：在必要范围内与我们的关联公司共享信息，以统一提供一致的服务体验；</li>
          <li><strong>微信生态服务</strong>：为使用微信登录、分享、客服功能，我们会向微信开放平台传输必要的标识信息。</li>
        </ul>

        <h3 class="subsection-title">4.2 转让</h3>
        <p class="main-content">
          我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：
        </p>
        <ul class="content-list">
          <li>在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
        </ul>

        <h3 class="subsection-title">4.3 公开披露</h3>
        <p class="main-content">
          我们仅会在以下情况下，公开披露您的个人信息：
        </p>
        <ul class="content-list">
          <li>获得您明确同意；</li>
          <li>基于法律法规规定、法律程序、诉讼或政府主管部门强制性要求。</li>
        </ul>

        <h2 class="section-title">5. 我们如何存储和保护您的个人信息</h2>
        
        <h3 class="subsection-title">5.1 存储地点</h3>
        <p class="main-content">
          我们依照法律法规的规定，将您的个人信息存储于<strong>中华人民共和国境内</strong>的服务器上。如需跨境传输，我们会单独征得您的同意，并确保接收方具备足够的数据保护能力。
        </p>

        <h3 class="subsection-title">5.2 存储期限</h3>
        <p class="main-content">
          我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求。例如：
        </p>
        <ul class="content-list">
          <li>账户信息：保留至您注销账户后【30】日；</li>
          <li>交易订单信息：保留至交易完成后【5】年（以满足税务、审计等法律要求）；</li>
          <li>日志信息：保留【6】个月；</li>
          <li>注销后的匿名化数据：可能被保留用于统计分析，但无法识别到您个人。</li>
        </ul>

        <h3 class="subsection-title">5.3 安全措施</h3>
        <p class="main-content">
          我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。具体措施包括：
        </p>
        <ul class="content-list">
          <li>使用加密技术（如SSL/TLS）确保数据传输安全；</li>
          <li>对敏感个人信息进行加密存储；</li>
          <li>实施严格的访问控制，仅允许有必要知晓的人员访问个人信息；</li>
          <li>定期开展安全审计与风险评估；</li>
          <li>制定数据安全事件应急预案。</li>
        </ul>
        <p class="main-content">
          尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。因此，您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
        </p>

        <h2 class="section-title">6. 您的权利</h2>
        <p class="main-content">
          按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
        </p>

        <h3 class="subsection-title">6.1 访问和更正</h3>
        <p class="main-content">
          您有权访问和更正您的个人信息。您可以在本应用"我的"→"信息管理"页面查看和修改您的昵称、头像等基本信息。如需修改其他信息，您可以通过本政策第10条提供的联系方式联系我们。
        </p>

        <h3 class="subsection-title">6.2 删除</h3>
        <p class="main-content">
          在以下情形中，您可以向我们提出删除个人信息的请求：
        </p>
        <ul class="content-list">
          <li>如果我们处理个人信息的行为违反法律法规；</li>
          <li>如果我们收集、使用您的个人信息，却未征得您的同意；</li>
          <li>如果我们处理个人信息的行为违反了与您的约定；</li>
          <li>如果您不再使用我们的产品或服务，或您注销了账号；</li>
          <li>如果我们不再为您提供产品或服务。</li>
        </ul>

        <h3 class="subsection-title">6.3 撤回同意</h3>
        <p class="main-content">
          您可以通过以下方式撤回您的授权同意：
        </p>
        <ul class="content-list">
          <li>设备系统设置中关闭相应权限（位置、相机、相册等）；</li>
          <li>注销您的账户；</li>
          <li>通过第10条联系方式联系我们提出撤回同意请求。</li>
        </ul>
        <p class="main-content">
          请注意，撤回同意不影响撤回前基于您的同意已进行的个人信息处理活动的效力。
        </p>

        <h3 class="subsection-title">6.4 注销账户</h3>
        <p class="main-content">
          您可以在"我的"页面申请注销账户。账户注销后，我们将停止为您提供产品或服务，并根据您的要求删除您的个人信息或进行匿名化处理，但法律法规另有规定的除外。
        </p>

        <h3 class="subsection-title">6.5 限制处理与可携带性</h3>
        <p class="main-content">
          在符合法律法规规定的情况下，您有权请求我们限制对您个人信息的处理，或请求以结构化、通用格式获取您提供给我们的个人信息。
        </p>

        <h3 class="subsection-title">6.6 响应您的请求</h3>
        <p class="main-content">
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在收到您的请求后【15】个工作日内作出答复。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。
        </p>

        <h2 class="section-title">7. 未成年人保护</h2>
        <p class="main-content">
          我们非常重视对未成年人个人信息的保护。
        </p>
        <ul class="content-list">
          <li>本应用主要面向成年人。若您是<strong>18周岁以下</strong>的未成年人，在使用我们的服务前，应确保事先取得监护人的同意；</li>
          <li>若您是<strong>14周岁以下</strong>的儿童，在使用我们的服务前，必须取得监护人的书面同意；</li>
          <li>我们不会主动直接向儿童收集个人信息。如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</li>
        </ul>
        <p class="main-content">
          如果您是监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策中的联系方式与我们联系。
        </p>

        <h2 class="section-title">8. 第三方链接和服务</h2>
        <p class="main-content">
          本应用可能包含指向第三方网站、服务或内容的链接。这些第三方有自己的隐私政策，我们不对其内容和隐私实践负责。我们建议您在向这些第三方提供任何个人信息之前，先阅读其隐私政策。
        </p>

        <h2 class="section-title">9. 隐私政策的更新</h2>
        <p class="main-content">
          我们可能会不时更新本隐私政策。当本政策发生重大变更时（如处理目的、处理方式、个人信息种类发生变化），我们会在应用内通过公告、弹窗等显著方式通知您，并重新征得您的同意（如适用）。
        </p>
        <p class="main-content">
          未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。您可以在应用"设置"或"关于"页面中查看本政策的最新版本。
        </p>

        <h2 class="section-title">10. 如何联系我们</h2>
        <p class="main-content">
          如果您对本隐私政策有任何疑问、意见或建议，或您认为您的个人信息权利可能受到侵害，请通过以下方式与我们联系：
        </p>
        <ul class="content-list">
          <li><strong>应用内反馈</strong>："我的"→"在线客服"</li>
          <li><strong>电子邮件</strong>：TFzszy@126.com</li>
          <li><strong>联系电话</strong>：028-83388891</li>
          <li><strong>联系地址</strong>：四川省成都市成华区龙潭街道国机西南大厦对面成华新经济产业服务中心</li>
        </ul>
        <p class="main-content">
          一般情况下，我们将在【15】个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：
        </p>
        <ul class="content-list">
          <li>向网信部门、电信主管部门、公安部门或市场监督管理局等监管机构投诉；</li>
          <li>向被告住所地有管辖权的人民法院提起诉讼。</li>
        </ul>

        <h2 class="section-title">11. 其他</h2>
        
        <h3 class="subsection-title">11.1 适用范围</h3>
        <p class="main-content">
          本隐私政策适用于"天府再生云"App（iOS版）及其提供的所有服务。本政策不适用于：
        </p>
        <ul class="content-list">
          <li>其他第三方提供的服务（如通过微信跳转的第三方小程序）；</li>
          <li>其他单独设有隐私政策的服务。</li>
        </ul>

        <h3 class="subsection-title">11.2 法律适用与争议解决</h3>
        <p class="main-content">
          本隐私政策的成立、生效、履行、解释及争议解决，均适用中华人民共和国法律（为本政策目的，不包括香港、澳门和台湾地区的法律）。
        </p>

        <div class="footer-info">
          <p><strong>天府再生云</strong></p>
          <p>更新时间：2026年7月9日</p>
          <p>版本号：V1.0</p>
        </div>
      </div>
    </div>
    <bottom-url class="bottomUrl" />
  </div>
</template>

<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';
export default {
  components: {
    BottomUrl,
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
  .header {
    width: 100% !important;
    height: 120px !important;
  }
  .main {
    width: 100% !important;
    padding: 10px !important;
  }
  .main-title {
    font-size: 20px !important;
  }
  .section-title {
    font-size: 16px !important;
  }
  .subsection-title {
    font-size: 14px !important;
  }
  .main-content {
    font-size: 14px !important;
  }
  .policy-table {
    font-size: 12px !important;
    th, td {
      padding: 8px !important;
    }
  }
}

.about-us {
  font-family: 微软雅黑;
  width: 100%;

  .header {
    width: 100%;
    height: 280px;
    line-height: 240px;
    text-align: center;
    background: url('~@/assets/recycling/index/about-us-bg.png') center/cover no-repeat;
    color: #ffffff;
    font-size: 36px;
    font-weight: 400;
    letter-spacing: 12px;
  }

  .main {
    width: 1080px;
    margin: 50px auto 84px;
    text-align: center;

    .main-title {
      color: rgb(34, 34, 34);
      font-size: 30px;
      font-weight: 700;
      letter-spacing: 4px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 30px;

      &::before,
      &::after {
        content: '';
        width: 300px;
        height: 1px;
        background: rgb(221, 221, 221);
        margin: 0 15px;
      }
    }

    .update-date {
      color: rgb(102, 102, 102);
      font-size: 14px;
      font-weight: 400;
      margin: 5px 0;
    }

    .policy-content {
      text-align: left;
      
      p {
        text-indent: 2em;
      }
    }

    .section-title {
      color: rgb(34, 34, 34);
      font-size: 22px;
      font-weight: 700;
      margin: 40px 0 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid rgb(67, 207, 124);
    }

    .subsection-title {
      color: rgb(51, 51, 51);
      font-size: 18px;
      font-weight: 600;
      margin: 25px 0 15px;
    }

    .main-content {
      margin-top: 15px;
      color: rgb(77, 81, 90);
      font-size: 16px;
      font-weight: 400;
      line-height: 180%;
      letter-spacing: 0px;
      text-align: left;
      text-indent: 2em;
    }

    .content-list {
      margin: 15px 0;
      padding-left: 4em;
      list-style-type: disc;
      
      li {
        color: rgb(77, 81, 90);
        font-size: 16px;
        font-weight: 400;
        line-height: 180%;
        margin: 10px 0;
        list-style-type: disc;
      }
    }

    .policy-table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;
      font-size: 14px;

      th, td {
        border: 1px solid rgb(221, 221, 221);
        padding: 12px;
        text-align: left;
      }

      th {
        background-color: rgb(67, 207, 124);
        color: white;
        font-weight: 600;
      }

      td {
        background-color: rgb(250, 250, 250);
      }

      tr:nth-child(even) td {
        background-color: rgb(245, 245, 245);
      }
    }

    .footer-info {
      margin-top: 50px;
      padding-top: 30px;
      border-top: 1px solid rgb(221, 221, 221);
      text-align: center;
      
      p {
        color: rgb(102, 102, 102);
        font-size: 14px;
        margin: 5px 0;
      }
    }
  }
}

.bottomUrl {
  margin-top: 60px;
}
</style>
